//=================================
// Flash popup video
//=================================
$(document).ready(function() {
	$('.custom').flashy({
		showClass: 'fx-fadeIn',
		hideClass: 'fx-fadeOut'
	});
    
});
